import{useLayoutEffect as e}from"react";function useResizeObserver(r,n){e(function(){if(null!=r.current){var e=new ResizeObserver(n);return e.observe(r.current),function(){return e.disconnect()}}},[r,n])}export{useResizeObserver as default};
//# sourceMappingURL=useResizeObserver.js.map
